<template>
  <div>
    <div style="margin-top:120px" class="res">
        <v-layout row wrap class="form-container">
            <v-flex xs3 sm3 md3 lg3>
                <v-card flat>
                    <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <avatar :size="40" :username="loggedInUserName"></avatar>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-sub-title style="font-size:13px;">Hello,</v-list-tile-sub-title>  
                <v-list-tile-title style="font-size:13px;">{{customer.fullName}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
                </v-card>

                <v-card flat style="margin-top:10px;background-color:white">
                    <v-list >
            <v-list-tile style="padding:0px;margin-top:0px;cursor:pointer" @click="profileBtn()">
              <v-list-tile-action>
                <v-icon color="primary">account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-sub-title style="font-size:14px">Profile Information </v-list-tile-sub-title>
            </v-list-tile>

            

            <v-list-tile style="padding:0px;margin-top:-10px;cursor:pointer" @click="addressBtn()">
              <v-list-tile-action>
                <v-icon color="primary">share_location</v-icon>
              </v-list-tile-action>
              <v-list-tile-sub-title style="font-size:14px">Manage Addresses</v-list-tile-sub-title>
            </v-list-tile>
            
          </v-list>
                </v-card>
            </v-flex>

            <v-flex xs9 sm9 md9 style="padding-left:10px" v-if="profile==true">
                <v-card flat>
                    <v-container>
                        <v-form ref="customer" v-model="valid" lazy-validation >
                        <v-layout row wrap>
                            <v-flex xs12>
                                <h4 style="text-align:center">Profile Information</h4>
                            </v-flex>

                            <v-flex xs12 style="padding-top:15px">
                             <v-text-field v-model="customer.fullName" label="Full Name" :rules="emptyRule" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="padding-top:15px">
                             <v-text-field disabled v-model="customer.mobileNumber" label="Mobile No" :rules="[rules.mobileno]" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="padding-top:15px">
                             <v-text-field v-model="customer.email" label="Email Address" :rules="[rules.email]" required></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="padding-top:15px;padding-right:5px">
                             <v-text-field v-model="customer.gstNumber" label="GST Number"></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="padding-top:15px">
                             <v-text-field v-model="customer.panNumber" label="PAN Number"></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="text-align:right">
                             <v-btn depressed color="primary" :loading="btnSave" @click="update(customer)">Update</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                    </v-container>
                    
                </v-card>
            </v-flex>


            <v-flex xs9 sm9 md9 style="padding-left:10px" v-if="manageAddress==true">
                <v-card flat>
                    <v-container>
                        <h4 style="text-align:center">Manage Addresses</h4>

                        <v-btn outline flat small depressed color="primary" @click.stop="addressDialog = true">Add an Address</v-btn>
                        <div style="border-left:1px solid;border-right:1px solid;border-bottom:1px solid;">
                            <div v-for="item in addressList" :key="item.id" style="padding:10px;border-top:1px solid"> 
                                <span style="font-size:11px;background-color:#e0e0e0;padding:5px;margin:10px">{{item.addressType}}</span>
                                <p style="padding:5px">{{item.name}}&nbsp;&nbsp;&nbsp;{{item.mobileNumber}}</p>
                                <p style="margin-top:-10px">{{item.address}}&nbsp;&nbsp;<span style="font-weight:bold">{{item.pinCode}}</span></p>
                                <div style="text-align:right">
                                    <v-icon color="primary" small @click="onEdit(item)">create</v-icon>
                                    <v-icon color="error" small @click="onDelete(item)">delete</v-icon>
                                </div>
                            </div>
                        </div>
                    </v-container>
                    
                </v-card>
            </v-flex>
        </v-layout>
    </div>


    <div style="margin-top:120px" class="man">
        <v-layout row wrap class="form-container">
            <v-flex xs12 sm12 md3 lg3>
                <v-card flat>
                    <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <avatar :size="40" :username="loggedInUserName"></avatar>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-sub-title style="font-size:13px;">Hello,</v-list-tile-sub-title>  
                <v-list-tile-title style="font-size:13px;">{{customer.fullName}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
                </v-card>

                <v-card flat style="margin-top:10px;background-color:white">
                    <v-list >
            <v-list-tile style="padding:0px;margin-top:0px;cursor:pointer" @click="profileBtn()">
              <v-list-tile-action>
                <v-icon color="primary">account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-sub-title style="font-size:14px">Profile Information </v-list-tile-sub-title>
            </v-list-tile>

            

            <v-list-tile style="padding:0px;margin-top:-10px;cursor:pointer" @click="addressBtn()">
              <v-list-tile-action>
                <v-icon color="primary">share_location</v-icon>
              </v-list-tile-action>
              <v-list-tile-sub-title style="font-size:14px">Manage Addresses</v-list-tile-sub-title>
            </v-list-tile>
            
          </v-list>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md9 style="padding-left:10px" v-if="profile==true">
                <v-card flat>
                    <v-container>
                        <v-form ref="customer" v-model="valid" lazy-validation >
                        <v-layout row wrap>
                            <v-flex xs12>
                                <h4 style="text-align:center">Profile Information</h4>
                            </v-flex>

                            <v-flex xs12 style="padding-top:15px">
                             <v-text-field v-model="customer.fullName" label="Full Name" :rules="emptyRule" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="padding-top:15px">
                             <v-text-field disabled v-model="customer.mobileNumber" label="Mobile No" :rules="[rules.mobileno]" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="padding-top:15px">
                             <v-text-field v-model="customer.email" label="Email Address" :rules="[rules.email]" required></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="padding-top:15px;padding-right:5px">
                             <v-text-field v-model="customer.gstNumber" label="GST Number"></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm6 md6 style="padding-top:15px">
                             <v-text-field v-model="customer.panNumber" label="PAN Number"></v-text-field>
                            </v-flex>
                            <v-flex xs12 style="text-align:right">
                             <v-btn depressed color="primary" :loading="btnSave" @click="update(customer)">Update</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                    </v-container>
                    
                </v-card>
            </v-flex>


            <v-flex xs12 sm12 md9 style="padding-left:10px" v-if="manageAddress==true">
                <v-card flat>
                    <v-container>
                        <h4 style="text-align:center">Manage Addresses</h4>

                        <v-btn outline flat small depressed color="primary" @click.stop="addressDialog = true">Add an Address</v-btn>
                        <div style="border-left:1px solid;border-right:1px solid;border-bottom:1px solid;">
                            <div v-for="item in addressList" :key="item.id" style="padding:10px;border-top:1px solid"> 
                                <span style="font-size:11px;background-color:#e0e0e0;padding:5px;margin:10px">{{item.addressType}}</span>
                                <p style="padding:5px">{{item.name}}&nbsp;&nbsp;&nbsp;{{item.mobileNumber}}</p>
                                <p style="margin-top:-10px">{{item.address}}&nbsp;&nbsp;<span style="font-weight:bold">{{item.pinCode}}</span></p>
                                <div style="text-align:right">
                                    <v-icon color="primary" small @click="onEdit(item)">create</v-icon>
                                    <v-icon color="error" small @click="onDelete(item)">delete</v-icon>
                                </div>
                            </div>
                        </div>
                    </v-container>
                    
                </v-card>
            </v-flex>
        </v-layout>
    </div>

    <v-dialog v-model="addressDialog" width="1000px">
      <v-card flat class="container">
              <h5 style="padding-top:120px">Add an Address</h5>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md6 style="padding-right:5px">
                    <v-text-field v-model="form.name" label="Name *" :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-text-field v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.locality" label="Locality *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.address" label="Address *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                    <v-text-field v-model="form.pinCode" label="Pincode *" type="number"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 style="padding-right:5px">
                    <v-text-field v-model="form.cityDistrictTown" label="City/Discrict/Town *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4>
                    <v-autocomplete
              v-model="selectedState"
              :items="states"
              color="primary"
              label="Select State *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="form.landMark" label="Landmark *"  :rules="emptyRule" required></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <b-form-radio-group
                   v-model="selected"
                  :options="options"
                  ></b-form-radio-group>
                  </v-flex>

                  <v-flex xs12 style="text-align:right">
                    <v-btn depressed color="#e53935" dark @click.stop="addressDialog=false">Cancel</v-btn>
                    <v-btn depressed :loading="btnSave1" color="primary" dark @click="onSubmit()">Save & Continue </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import config from "./../../config.json";
import Avatar from "vue-avatar";
export default {
    components: {
    Avatar
  },
  data() {
    return {
        menu: false,
        btnSave: false,
        profile: true,
        manageAddress: false,
        addressList: [],
        valid: true,
      customer: {},
      loggedInUserName: sessionStorage.loggedInUserName,

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
      btnSave1: false,
      address: [],
      addressDialog: false,
      selectedAddress: {
        id: null,
        name: null,
        mobileNumber: null,
        address: null,
        pinCode: null
      },
      selectedAddress1: null,

      form: {
        name: null,
        mobileNumber: null,
        pinCode: null,
        address: null,
        landMark: null,
        locality: null,
        cityDistrictTown: null,
        alternateNumber: null
      },

      selected: "Home Address",
      options: ["Home Address", "Office Address"],

      selected1: "Cash on Delivery",
      options1: ["Cash on Delivery", "Online Payment"],

      states: [],
      selectedState: null,
    };
  },

  mounted() {
      this.getData();

      this.axios
        .get(config.API + "States", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
        });
  },
  methods: {
      profileBtn() {
          this.manageAddress = false;
          this.profile = true;
      },
      addressBtn() {
          this.manageAddress = true;
          this.profile = false;
      },
      getData() {
        this.axios
        .get(config.API + "MyProfile", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.customer = res.data;
          this.addressList = res.data.customerAddresses;
          this.$Progress.finish();
        });
      },

    update(item) {
      if (this.$refs.customer.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `MyProfile/${item.id}`,
            {
              id: JSON.parse(item.id),
              fullName: item.fullName,
              email: item.email,
              gstNumber: item.gstNumber,
              panNumber: item.panNumber
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            //this.$router.push(`counsellingImage/${code}`);
            this.getData();
            this.btnSave = false;
          })
          .catch(err => {
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave1 = true;
        this.axios
          .post(
            config.API + `CustomerAddresses`,
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              pinCode: JSON.parse(this.form.pinCode),
              address: this.form.address,
              locality: this.form.locality,
              cityDistrictTown: this.form.cityDistrictTown,
              landMark: this.form.landMark,
              alternateNumber: this.form.alternateNumber,
              stateCode: JSON.parse(this.selectedState),
              addressType: this.selected
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully added");
            this.getData();
            this.btnSave1 = false;
            this.addressDialog = false;
          })
          .catch(err => {
            this.$toaster.error('"wong');
            this.btnSave1 = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },
    onEdit(item) {
      this.$router.push(`customerAddress/${item.id}`);
    },

    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to delete this Address !!")) {
        this.axios
          .delete(config.API + `CustomerAddresses/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Deleted successfully");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Sora:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
</style>
<style lang="css" scoped>
.covid {
  font-family: 'Quicksand', sans-serif;
  font-size: 12px;
  font-weight: bold;
}
.hdr {
 font-size: 50px;
 color: #e0e0e0;
}
.hdr1 {
 color: #e0e0e0;
}
.txt {
 font-family: 'Mulish', sans-serif;
}
.txtt {
 font-family: 'Sora', sans-serif;
}
.lftsid {
  background-color: black !important;
  background-size: cover;
  box-shadow: none !important;
  border-radius: 0px !important;
  height: 350px;
}
.login-form {
  padding: 40px;
}
.bckcolor {
  background-image: url("../../assets/loginbg.jpg");
  background-size: cover;
}
.cursr {
  cursor: pointer;
}
.v-btn {
  margin-left: 0px;
}
.txt_dec:hover {
    text-decoration: underline !important;
}
.loginPage {
  background-size:cover
}
.call-button-container {
  margin: auto;
  width: 233px;
  height: 74px;
  vertical-align: middle;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
</style>
